var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title"},[_vm._v("院校特色")]),_vm._l((_vm.list),function(item,i){return _c('div',{key:i,staticClass:"nav"},[_c('div',{staticClass:"specialty_name"},[_vm._v(_vm._s(item.specialty_name))]),_c('div',{staticClass:"level"},[_vm._v(_vm._s(item.level))])])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }